import React, { useCallback, useEffect, useRef } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import Header from '../../components/Header';
import StandardContainer from '../../components/StandardContainer';
import api from '../../services/api';
import { Content } from './styles';
import { Form } from '@unform/web';
import { SimpleTable } from '../../components/SimpleTable';
import Button from '../../components/Button';
import { FormHandles } from '@unform/core';
import Select from '../../components/Select';
import { useLocation } from 'react-router-dom';
import { useToast } from '../../hooks/toast';

interface Data {
  id: string;
  code: number;
  name: string;
  email: string;
  phone: string;
  accept_type: string;
  created_at: string;
  image: string;
  imageLink: string;
}

interface IUsers {
  id: number;
  name: string;
  email: string;
  phone: string;
  accept_type: string;
  created_at: string;
  image: string;
  imageLink: string;
}

function createData(
  id: string,
  code: number,
  name: string,
  email: string,
  phone: string,
  accept_type: string,
  created_at: string,
  image: string,
  imageLink: string,
): Data {
  return {
    id,
    code,
    name,
    email,
    phone,
    accept_type,
    created_at,
    image,
    imageLink,
  };
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
}

interface IParams {
  state: {
    game: string;
  };
}

const Game = () => {
  const { state }: { state: IParams } = useLocation();
  const [rows, setRows] = useState<IUsers[]>([]);
  const [loading, setLoading] = useState(true);
  const formRef = useRef<FormHandles>(null);
  const headers = [
    { fieldName: 'code', label: 'ID' },
    { fieldName: 'name', label: 'Nome' },
    { fieldName: 'email', label: 'Email' },
    { fieldName: 'phone', label: 'Telefone' },
    { fieldName: 'accept_type', label: 'Aceite' },
    { fieldName: 'created_at', label: 'Aceite LGPD' },
    { fieldName: 'image', label: 'Foto' },
  ];
  const [selectedGame, setSelectedGame] = useState<string>(
    state?.state.game ? state?.state?.game : 'all',
  );
  const { addToast } = useToast();

  const [gameType, setGameType] = useState<{ label: string; value: string }[]>([
    { value: 'game_web', label: 'Game Web' },
    { value: 'game_app', label: 'Game App' },
    { value: 'game_family_devotees', label: 'Game Família Devotos' },
    { value: 'all', label: 'Todos' },
  ]);

  const getRows = useCallback(
    async (game = 'all') => {
      setLoading(true);
      try {
        console.log(`Carregando dados para o filtro: ${game}`);
        const response = await api.get(`/usersgame/filter-by-game/${game}`);
        setRows(response.data);
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
        addToast({
          type: 'error',
          title: 'Erro ao buscar dados',
          description: 'Ocorreu um erro ao buscar os usuários.',
        });
      }
      setLoading(false);
    },
    [addToast],
  );

  useEffect(() => {
    getRows('all');
  }, [getRows]);

  const handleSubmitFilter = async (event: React.FormEvent) => {
    const data = formRef.current?.getData();
    const selectedGame = data?.game;

    console.log('Filtro acionado com valor:', selectedGame);

    if (!selectedGame) {
      addToast({
        type: 'error',
        title: 'Valores inválidos',
        description: 'Selecione um game para filtrar',
      });
      return;
    }

    getRows(selectedGame);
  };

  const usersRows = useMemo(() => {
    return rows.map(row =>
      createData(
        row.id.toString(),
        row.id,
        row.name,
        row.email,
        row.phone,
        row.accept_type,
        row.created_at,
        row.image,
        row.imageLink,
      ),
    );
  }, [rows]);

  return (
    <StandardContainer>
      <Header />
      <Content>
        <Form
          ref={formRef}
          onSubmit={handleSubmitFilter}
          style={{
            flexDirection: 'row',
            display: 'flex',
            width: '100%',
            alignItems: 'flex-end',
            marginBottom: 20,
          }}
        >
          <div>
            <div>
              <Select
                name="game"
                label="Selecione o Game"
                defaultOption={state?.state.game || 'all'}
                options={gameType}
                // onChange={handleSelectedGame}
                style={{ width: '400px', marginRight: '18px' }}
              />
            </div>
            <div>
              <Button
                type="submit"
                loading={loading}
                style={{ width: 200, marginLeft: 10 }}
              >
                Filtrar
              </Button>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '20px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  marginTop: '25px',
                }}
              ></div>
            </div>
          </div>
        </Form>
        <SimpleTable data={usersRows} headers={headers} />
      </Content>
    </StandardContainer>
  );
};

export default Game;
